import { alignItems, strCode } from "../../../../../consts";
import { t } from "../../../../../services";

import { FlexContainers, Paragraph2 } from "../../../../../components";
import { OptionsInfoWrapper } from "./styled";

export const ReleaseNotesOptionsInfo = () => {
  return (
    <OptionsInfoWrapper
      Container={FlexContainers.FlexColumnStart}
      alignItems={alignItems.start}
      maxWidth={390}
      pv={4}
      gap={24}>
      <Paragraph2>
        <b>{t(strCode.SIMLE_LIST_TITLE)}: </b>
        {t(strCode.SIMLE_LIST_DESCRIPTION)}
      </Paragraph2>

      <Paragraph2>
        <b>{t(strCode.LIST_WITH_ICONS_TITLE)}: </b>
        {t(strCode.LIST_WITH_ICONS_DESCRIPTION)}
      </Paragraph2>

      <Paragraph2>
        <b>{t(strCode.CAROUSEL_TITLE)}: </b>
        {t(strCode.CAROUSEL_DESCRIPTION)}
      </Paragraph2>
    </OptionsInfoWrapper>
  );
};
